import React, { MouseEvent, PureComponent } from 'react'
import { connect } from 'react-redux';
import { addTodo, inittodoFB, inittodoFBNoId } from '../redux/actions';

// interface inittodo{
//     createdAt: string,
//     title: string,  desc: string,  todoId: number,    
//     userId: number,    completed: string,   tags: string

// }

interface Props {
    todos: object[],    
    uem: string, 
    addTodo: Function,
    // initialTodo: inittodoFB
    initialTodo: inittodoFBNoId
}

interface State {
    todoItem: object | inittodoFBNoId | any
}

class TodoHeader extends React.PureComponent<Props, State> {

    dt: Date;
    constructor(props: Props){
        super(props);
        this.dt = new Date();
        this.state = { 
            todoItem: {...this.props.initialTodo},
        }    
    }

    handleChange = (e: any) => {
        this.setState({ ...this.state, todoItem: { ...this.state.todoItem, [e.target.name]: e.target.value,
            todoId: this.props.todos.length+1
        } })       
        console.log( this.state.todoItem );
         
    }   
    
    handelInsert = (e: MouseEvent) => { 
        e.preventDefault();
        if( this.state.todoItem.title.length > 0 && this.state.todoItem.desc.length > 0 ){  
            this.props.addTodo(this.state.todoItem, this.props.uem);
            console.log(this.state.todoItem, this.props.uem);        
            // this.setState({ ...this.state, todoItem:{ createdAt: this.dt.toLocaleString().substring( 0, this.dt.toLocaleString().indexOf(",") ), title: '',  desc: '', todoId: 0,   userId: 1,  completed: 'false',   tags: '' } })
            this.setState({ ...this.state, todoItem:{ ...this.props.initialTodo }});
        }                
    };

    render() {
        const {todos, uem, initialTodo, addTodo} = this.props;
        return (
            <section className="todo-insert">
                <h3>Type Todo Details : </h3>
                <div>
                    <p>Title</p>
                    <input type="text" name="title" onChange={(e) => this.handleChange(e)} value={this.state.todoItem.title} placeholder='type todo title'/>
                </div>
                <div>
                    <p>Description</p>
                    <textarea name="desc" onChange={(e) => this.handleChange(e)} value={this.state.todoItem.desc} placeholder='type todo description'> </textarea>
                </div>         
                <div>
                    <p>Tags</p>
                    <input type="text" name="tags" onChange={(e) => this.handleChange(e)} value={this.state.todoItem.tags}  placeholder={`type todo tags -> 'tag1 tag2 tag3'`}/>
                </div>         
                <button type="button" onClick={this.handelInsert}>Add Todo</button>    
            </section>
        )
    }
}

// export default TodoHeader
const mapDispatchToProps = (dispatch:any) => {
    return{
        addTodo : (todoItem:inittodoFBNoId, uem:string) => dispatch(addTodo(todoItem, uem))
    }
}
export default connect( null, mapDispatchToProps )( TodoHeader )